module.exports = __webpack_public_path__ + "media/images/country_flags/my-d5d877f8046ff15e76cfa6c1db05925b.png";